'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _ = require('lodash');
var rangeRegex = /^(\d|\d{2}|1\d{2}|2\d{2}|3[0-6][0-5])H?:(\d|\d{2}|1\d{2}|2\d{2}|3[0-6][0-5])H?$/i;
var filedMinStayRegex = /^%*((\d|\d{2}|1\d{2}|2\d{2}|3[0-6][0-5])H?|(SUN|MON|TUE|WED|THU|FRI|SAT)\d{2}|[1-7]{0,7}-((\d|\d{2}|1\d{2}|2\d{2}|3[0-6][0-5])H?|(SUN|MON|TUE|WED|THU|FRI|SAT)\d{2})|%)(([&/]((\d|\d{2}|1\d{2}|2\d{2}|3[0-6][0-5])H?|(SUN|MON|TUE|WED|THU|FRI|SAT)\d{2}|[1-7]{0,7}-((\d|\d{2}|1\d{2}|2\d{2}|3[0-6][0-5])H?|(SUN|MON|TUE|WED|THU|FRI|SAT)\d{2})|%))*)%*$/i;
var mappedMinStayRegex = /^((\d|\d{2}|1\d{2}|2\d{2}|3[0-6][0-5])H?|(SUN|MON|TUE|WED|THU|FRI|SAT)\d{2}|[1-7]{0,7}-((\d|\d{2}|1\d{2}|2\d{2}|3[0-6][0-5])H?|(SUN|MON|TUE|WED|THU|FRI|SAT)\d{2}))(([&/]((\d|\d{2}|1\d{2}|2\d{2}|3[0-6][0-5])H?|(SUN|MON|TUE|WED|THU|FRI|SAT)\d{2}|[1-7]{0,7}-((\d|\d{2}|1\d{2}|2\d{2}|3[0-6][0-5])H?|(SUN|MON|TUE|WED|THU|FRI|SAT)\d{2})))*)$/i;
var MinStayUtilityService = function MinStayUtilityService() {
  function isRange(filedMinStay) {
    return filedMinStay.includes(':');
  }
  function validateFiledMinStay(filedMinStay) {
    return isRange(filedMinStay) ? rangeRegex.test(filedMinStay) && isRangeValid(filedMinStay) : filedMinStayRegex.test(filedMinStay);
  }
  function validateFiledMinStays(filedMinStays) {
    var isValid = true;
    if (invalidUseOfSpecialCharactersForMinStay(filedMinStays, 'multiple')) {
      return false;
    }
    _.forEach(filedMinStays.split(','), function (value) {
      return isValid = isValid && validateFiledMinStay(value);
    });
    return isValid;
  }
  function validateMappedMinStay(mappedMinStay, occurrence) {
    if (invalidUseOfSpecialCharactersForMinStay(mappedMinStay, occurrence)) {
      return false;
    }
    var isValid = true;
    _.forEach(mappedMinStay.split(','), function (value) {
      return isValid = isValid && mappedMinStayRegex.test(value);
    });
    return isValid;
  }
  function getResolvedMinStay(value) {
    value = value.toUpperCase();
    return value.includes('H') ? convertHoursToDays(value.split('H')[0]) : parseFloat(value);
  }
  function convertHoursToDays(value) {
    return parseFloat(value) / 24;
  }
  function invalidUseOfSpecialCharactersForMinStay(value, occurrence) {
    var delimiters = [',', '/', '&', '-'];
    if (occurrence === 'single' && (value.includes(',') || value.includes(':'))) {
      return true;
    }
    return delimiters.some(function (delimiter) {
      return value.includes(delimiter) && areComponentsLessThanOrEqualToDelimiter(delimiter, value);
    });
  }
  function areComponentsLessThanOrEqualToDelimiter(symbol, value) {
    var components = _.chain(value.split(symbol)).filter(function (str) {
      return !_.isEmpty(str);
    }).value();
    return components.length <= countOccurrences(symbol, value);
  }
  function countOccurrences(symbol, str) {
    var matches = str.match(new RegExp(symbol, 'g'));
    return matches ? matches.length : 0;
  }
  function transformUpperCaseAndSortedMinStay(minStay) {
    var modifiedMinStay = minStay.split(',').map(function (values) {
      var valuesWithDowInd = values.split('-');
      for (var i = 0; i < valuesWithDowInd.length - 1; i++) {
        var onlyDow = extractDOWInd(valuesWithDowInd[i]);
        var dowInd = (0, _toConsumableArray2["default"])(new Set(onlyDow.match(/\d/g)));
        var sortedDow = dowInd.sort(function (a, b) {
          return a - b;
        }).join('');
        valuesWithDowInd[i] = valuesWithDowInd[i].replace(onlyDow, sortedDow);
      }
      return valuesWithDowInd.join('-');
    }).join(',');
    return modifiedMinStay.toUpperCase();
  }
  function extractDOWInd(dowComponent) {
    return getLastValue(getLastValue(dowComponent.split('/')).split('&'));
  }
  function getLastValue(separatedDow) {
    return separatedDow[separatedDow.length - 1];
  }
  function isRangeValid(value) {
    if (value.includes(':')) {
      var range = value.split(':');
      var start = getResolvedMinStay(range[0]);
      var end = getResolvedMinStay(range[1]);
      return start < end;
    }
    return true;
  }
  return {
    validateFiledMinStays: validateFiledMinStays,
    validateMappedMinStay: validateMappedMinStay,
    getResolvedMinStay: getResolvedMinStay,
    transformUpperCaseAndSortedMinStay: transformUpperCaseAndSortedMinStay
  };
};
module.exports = MinStayUtilityService;